import React from 'react';

import {useStore} from 'effector-react';

import {
    CUSTOMS_NAVIGATION_LINKS,
    LinkData,
    NAVIGATION_LINKS,
    NavigationLinksShowEnum,
} from 'core/navigationLinks';

import {ROUTE} from 'core/routes';

import {$mainRole, isAdmin$} from 'models/auth';

import {UserRoles} from 'types';

import {MenuIcon, MenuItem, MenuItemTitle, SidebarMenu} from './styled';

interface Props {
    isMobile?: boolean;
    onClickHandler?: Function;
}

export function SidebarNavigation({isMobile, onClickHandler = () => {}}: Props) {
    const isAdmin = useStore(isAdmin$);
    const EXTRA_ACTIVE_PATH_FOR_DOCUMENTS = {
        [ROUTE.DOCUMENTS_DOCUMENTS]: true,
        [ROUTE.DOCUMENTS_INVOICES]: true,
        [ROUTE.DOCUMENTS_CHECKS]: true,
        [ROUTE.DOCUMENTS_INVOICES_INCOMING]: true,
        [ROUTE.DOCUMENTS_INVOICES_OUTGOING]: true,
        [ROUTE.DOCUMENTS_GDS]: true,
        [ROUTE.DOCUMENTS_GDS_CREATE]: true,
    };

    const NAVIGATION_MAP: {DEFAULT: LinkData[]} & Partial<Record<UserRoles, LinkData[]>> = {
        [UserRoles.ROLE_MPL_TS_DIRECTOR]: CUSTOMS_NAVIGATION_LINKS,
        [UserRoles.ROLE_MPL_TS_EMPLOYEE]: CUSTOMS_NAVIGATION_LINKS.filter(
            (link) => link.route !== ROUTE.DOCUMENTS_DOCUMENTS,
        ),
        DEFAULT: NAVIGATION_LINKS.filter((link) => {
            if (link.route === ROUTE.DECLARATIONS) {
                return isAdmin;
            }
            return true;
        }),
    };

    const ROLE = useStore($mainRole);
    const NAVIGATION = NAVIGATION_MAP[ROLE || 'DEFAULT'] ?? NAVIGATION_MAP.DEFAULT;

    const links = NAVIGATION.filter(
        (link) => link.showOn !== NavigationLinksShowEnum[isMobile ? 'desktop' : 'mobile'],
    );

    return (
        <SidebarMenu>
            {links.map((item, index) => (
                <MenuItem
                    to={item.route}
                    key={index}
                    isActive={(match: any, location) =>
                        (item.route === ROUTE.DOCUMENTS_DOCUMENTS &&
                            location.pathname.startsWith(ROUTE.DOCUMENTS_INVOICES)) ||
                        (item.route === ROUTE.DOCUMENTS_DOCUMENTS &&
                            location.pathname.startsWith('/gds/')) ||
                        location.pathname.startsWith(item.route) ||
                        (item.route === ROUTE.DOCUMENTS_DOCUMENTS &&
                            location.pathname in EXTRA_ACTIVE_PATH_FOR_DOCUMENTS) ||
                        match
                    }
                    onClick={(e: any) => item.onClick?.(e) ?? onClickHandler(e)}
                >
                    <MenuIcon>{item.icon}</MenuIcon>
                    <MenuItemTitle>{item.title}</MenuItemTitle>
                </MenuItem>
            ))}
        </SidebarMenu>
    );
}
